// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__QE_XJ","savePackageButton":"ClientWallet_savePackageButton__1wP3t"};